import {BaseSearchDTO} from "../baseSearchDTO.interface";

export interface VehicleFaultItemSearchDTO extends BaseSearchDTO {
  filters?: {
  };
}
